import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import { isNil } from 'ramda'

import type { HeroCenteredTransparentComponent } from '@twisto/api-cms'

import { StrapiMedia } from 'homepage/components/atoms'
import { useUrlWithParams } from 'homepage/libs/hooks'

import { HeroDescription } from '../../hero-description'
import { HeroTitle } from '../../hero-title'

import * as styles from './centered-transparent.styles'

export const CenteredTransparent = ({
  title,
  highlightedTitle,
  description,
  descriptionHighlighted,
  cta,
  image,
}: HeroCenteredTransparentComponent) => {
  const ctaUrl = useUrlWithParams(cta?.link, cta?.includeUrlParams)

  return (
    <div>
      <div css={styles.content}>
        <div css={styles.hero}>
          <div css={styles.heroCell}>
            <div css={styles.cellContent}>
              {title && (
                <HeroTitle highlighted={highlightedTitle} title={title} />
              )}
              {description && (
                <HeroDescription
                  description={description}
                  highlighted={descriptionHighlighted}
                />
              )}
              {cta?.text && cta.link && (
                <div css={styles.cta}>
                  <TextButton css={styles.button} href={ctaUrl}>
                    {cta.text}
                  </TextButton>
                </div>
              )}
            </div>
          </div>
          <figure css={styles.figure}>
            <div>
              {!isNil(image?.url) && <StrapiMedia priority {...image} />}
            </div>
          </figure>
        </div>
      </div>
    </div>
  )
}
